import type {RouteParams} from 'types/routes'
import {MYPAGE_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/mypage/procedures/parentalLeaveSupportAllowance/index'
import {ParentalLeaveSupportAllowanceFlow} from 'pages/withAuth/mypage/procedures/parentalLeaveSupportAllowance/flow'

export const ParentalLeaveSupportAllowanceRoutes: RouteParams[] = [
  {
    key: '/mypage/parental_leave_support_allowance',
    path: MYPAGE_PATHS.PROCEDURES.PARENTAL_LEAVE_SUPPORT_ALLOWANCE.INDEX,
    component: Index,
    exact: true,
  },
  {
    key: '/mypage/parental_leave_support_allowance/flow/:id',
    path: MYPAGE_PATHS.PROCEDURES.PARENTAL_LEAVE_SUPPORT_ALLOWANCE.FLOW,
    component: ParentalLeaveSupportAllowanceFlow,
    exact: true,
  },
]
